import React, { FC } from "react"
import { FleLayout } from "./FleLayout"
import { BackArrow, SkipArrow, SwitchH2ToBodyLarge } from "./Molecules"
import L10n from "../../../lib/carrot-l10n"
import { TopSection } from "./TopSection"
import { Button } from "../atoms/buttons/Button"
import { Spacer } from "../atoms/Atoms"
import { FleLinkWrapper } from "../atoms/Links"
import { updateUserInfo } from "../../../actions/userActions"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { getInterestSpecificData } from "../../../reducers/userInfo"
import { InterestSpecificDataOptions } from "../../../utils/InterestSpecificDataOptions"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type HowLongTryingProps = {
  next: string
}

const HowLongTrying: FC<HowLongTryingProps> = ({ next }) => (
  <FleLayout>
    <TopSection progressStep={4} leftOrBackArrow={<BackArrow />} />
    <SwitchH2ToBodyLarge>{l`How long have you been trying to get pregnant?`}</SwitchH2ToBodyLarge>
    <Spacer height={2} />
    <HowLongTryingButtons next={next} />
    <FleLinkWrapper>
      <SkipArrow to={next} />
    </FleLinkWrapper>
  </FleLayout>
)

type HowLongTryingButtonsProps = {
  next: string
}

const HowLongTryingButtons: FC<HowLongTryingButtonsProps> = ({ next }) => (
  <>
    {TryingTimeSpans.map((tryingTimeSpan) => (
      <HowLongTryingButton key={tryingTimeSpan.id} tryingTimeSpan={tryingTimeSpan} next={next} />
    ))}
  </>
)

type TryingTimeSpan = {
  text: string
  id: string
}
const TryingTimeSpans: TryingTimeSpan[] = [
  {
    text: l`Less than a month`,
    id: InterestSpecificDataOptions.LESS_THAN_A_MONTH
  },
  {
    text: l`1-3 months`,
    id: InterestSpecificDataOptions.ONE_TO_THREE_MONTHS
  },
  {
    text: l`3-6 months`,
    id: InterestSpecificDataOptions.THREE_TO_SIX_MONTHS
  },
  {
    text: l`6-12 months`,
    id: InterestSpecificDataOptions.SIX_TO_TWELVE_MONTHS
  },
  {
    text: l`More than a year`,
    id: InterestSpecificDataOptions.MORE_THAN_A_YEAR
  }
]

type HowLongTryingButtonProps = {
  tryingTimeSpan: TryingTimeSpan
  next: string
}

const HowLongTryingButton: FC<HowLongTryingButtonProps> = ({ tryingTimeSpan, next }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const interestSpecificData = useSelector(getInterestSpecificData)

  const submitTimeSpan = async (tryingTimeSpan: TryingTimeSpan) => {
    await dispatch(updateUserInfo({ interestSpecificData: tryingTimeSpan.id }))
    history.push(next)
  }

  return (
    <div key={tryingTimeSpan.id} className="flex flex-row justify-end w-100 mb1">
      <Button
        bold={false}
        onClick={() => submitTimeSpan(tryingTimeSpan)}
        outline={interestSpecificData === tryingTimeSpan.id}
      >
        {tryingTimeSpan.text}
      </Button>
    </div>
  )
}

export { HowLongTrying }
